import { useParams } from "react-router";
import { EmptyGrowPanelText, MessageBox } from "styles/text";
import {
  selectIsActivePickem,
  selectPickemDetails,
} from "selectors/PickemDetails";
import {
  selectTournamentName,
  selectTournamentRosterScope,
  selectTournamentSegment,
} from "selectors/Tournament";
import { PickemInformationPanel } from "components/Pickem/Picker/PickemInformationPanel";
import { PickemPicker } from "components/Pickem/Picker/PickemPicker";
import { Panel } from "components/Panel/Panel";
import { SingleColumnPage } from "pages/PageTemplates";
import { useAppSelector } from "app/hooks";

export const PickemMakePicksPage = () => {
  const { tournamentId, pickemId } = useParams();
  const pickemDetails = useAppSelector((state) =>
    selectPickemDetails(state, tournamentId, pickemId)
  );

  const tournamentSegment = useAppSelector((state) =>
    selectTournamentSegment(
      state,
      pickemDetails?.tournamentId,
      pickemDetails?.segmentId
    )
  );

  const tournamentName = useAppSelector((state) =>
    selectTournamentName(state, pickemDetails?.tournamentId)
  );

  const rosterScope = useAppSelector((state) =>
    !!tournamentId
      ? selectTournamentRosterScope(state, tournamentId)
      : undefined
  );

  const isActivePickem = useAppSelector((state) =>
    !!pickemDetails ? selectIsActivePickem(state, pickemDetails) : false
  );

  return (
    <SingleColumnPage>
      {!!pickemDetails && !!tournamentSegment && !!rosterScope ? (
        <>
          {!isActivePickem && (
            <Panel type="warning" padding="padded">
              This Pickem is not currently active.
            </Panel>
          )}
          {!!pickemDetails.message && (
            <MessageBox>{pickemDetails.message}</MessageBox>
          )}
          <PickemInformationPanel
            header={`${tournamentName} - ${pickemDetails.name}`}
            pickemDetails={pickemDetails}
          />
          <PickemPicker
            pickemDetails={pickemDetails}
            tournamentSegment={tournamentSegment}
          />
        </>
      ) : (
        <Panel>
          <EmptyGrowPanelText>Unable to find pickem</EmptyGrowPanelText>
        </Panel>
      )}
    </SingleColumnPage>
  );
};
